import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root',
})
export class ThemeService {
   constructor(@Inject(DOCUMENT) private document: Document) {}

   setVariable(name, value) {
      this.document.documentElement.style.setProperty(name, value);
   }

   setDarkLightMode() {
      const $html = document.querySelector('html');
      $html.classList.toggle('dark-mode');

      if ($html.classList.value.includes('dark-mode')) {
         localStorage.setItem('pede-mais-garcom-theme', 'dark-mode');
      } else {
         localStorage.setItem('pede-mais-garcom-theme', 'light-mode');
      }
   }

   isDarkMode() {
      const theme = localStorage.getItem('pede-mais-garcom-theme');
      return theme === 'dark-mode';
   }
}
